import createInitialState from "../../../lib/importer/create-initial-state";
import createReducer from "../../../lib/importer/create-reducer";

const initialState = createInitialState();

export default createReducer("CONTACTS", initialState);
